import { IIndicatorsLevel } from "src/pages/Indicators/Panel/components/interface";
import styled from "styled-components";
import { IContainerChartContentIndicatorsPanel } from "./interface";

const ContainerChartContentIndicatorsPanel = styled.div<IContainerChartContentIndicatorsPanel>`
    display: flex;
    flex-direction: column;
    width: 100%;

    padding: 2px;
    margin: 1rem 0;

    border: 1px solid var(--border-color);
    border-radius: 10px;

    .indicatorsChartContainer{ 
        min-height: 400px; 
    }

    ${(props) => props.level === IIndicatorsLevel.STRATEGIC ? "border-left: 2px solid var(--purple)" : ""}
    ${(props) => props.level === IIndicatorsLevel.OPERATIONAL ? "border-left: 2px solid var(--orange)" : ""}
    ${(props) => props.level === IIndicatorsLevel.TACTIC ? "border-left: 2px solid var(--blue)" : ""}
`;

export default ContainerChartContentIndicatorsPanel;

